export default {
  name: 'home',
  components: {
  },

  data() {
    return {
      shows: false,
      msg: ''
    }
  },
  created() {
  },
  mounted: function () {
    // this.testLogin();
    if (this.$route.query.code) {
      this.getInfo(this.$route.query.code)
    }
  },
  methods: {
    testLogin(){
      
      this.apiGet('/h5/api/weixin/auth/testLogin', {}, res => {
        if (res.state) {
          sessionStorage.setItem('token', res.data)
          sessionStorage.setItem('loginInfo', JSON.stringify(res.data))
          // window.location.href = '/home'
        } else {
        }
      })
    },
    toMy: function() {
      window.location.href = '/my'
    },
    getInfo: function (code) {
      this.apiGet('/h5/api/weixin/auth', { code: code }, res => {
        console.log('333333333')
        if (res.state) {
          sessionStorage.setItem('token', res.data)
          sessionStorage.setItem('loginInfo', JSON.stringify(res.data))
          let groupCode = localStorage.getItem('groupCode')
          console.log('groupCode=====' + groupCode)
          this.apiGet('/h5/api/user/addGorup', { groupCode: groupCode }, res => {
            this.msg = res.msg
            this.shows = true
            if (res.state) {

            }
          })
        } else {

        }
      })
    },
    resets: function () {
      this.params.img = ''
      this.params.name = ''
      this.params.order_num = ''
      this.localIds = ''
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/group-add/group-add.js